export function worktime() {

    function showWorktimeDesk() {
        const showWorkTime = document.querySelector('.js-showWorkTime');
        const workTimeBlock = document.querySelector('.js-workTimeBlock');

        if (window.innerWidth < 768) {
            return false;
        }

        ['mouseleave', 'mouseenter'].forEach( item => {
            showWorkTime.addEventListener(item, () => {
                workTimeBlock.classList.toggle('is-active');
            });
        });
    }

    function showHeaderCityMob() {
        let windowScroll = document.documentElement.scrollTop || document.body.scrollTop;

        const headerCityMob = document.querySelector('.js-headerCityMob');
        const logoWrapper = document.querySelector('.js-logoWrapper');

        if (windowScroll > 10) {
            headerCityMob.classList.add('is-active');
            logoWrapper.classList.add('is-active');
        } else {
            headerCityMob.classList.remove('is-active');
            logoWrapper.classList.remove('is-active');
        }
    }

    function initHeaderCityMob() {
        if (window.innerWidth < 768) {
            showHeaderCityMob();
            window.addEventListener('scroll', showHeaderCityMob);
        } else {
            window.removeEventListener('scroll', showHeaderCityMob);
        }
    }

    function adaptive(script) {
        script();

        ['resize', 'orientationChange'].forEach( item => {
            window.addEventListener(item, script);
        });
    }

    adaptive(showWorktimeDesk);
    adaptive(initHeaderCityMob);
}

